import * as Sentry from '@sentry/react';
import {Integrations} from '@sentry/tracing';

const initSentry = () => {
  Sentry.init({
    dsn: process.env.SENTRY_DSN ?? '',
    release: process.env.SENTRY_RELEASE ?? '',
    environment: process.env.SENTRY_ENVIRONMENT ?? 'development',
    integrations: [new Integrations.BrowserTracing()],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 0.1,
    // This sets the sample rate to be 10%. You may want this to be 100% while
    // in development and sample at a lower rate in production
    replaysSessionSampleRate: 0.1,
    // If the entire session is not sampled, use the below sample rate to sample
    // sessions when an error occurs.
    replaysOnErrorSampleRate: 1.0,
  });
};

export default initSentry;
